export default {
    currentValue: null,
    satisfaction: null,
    generalComments: null,
    difficultiesFound: null,
    rangeId: null,
    isCheckInByRange: null,
    evidence: null,
}
